import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { RoutesPage } from "./constants";
import Navbar from "./pages/Navbar";
import "./App.css";

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        {RoutesPage.map((route, index) => (
          <Route key={index} path={route.path} element={route.element} />
        ))}
      </Routes>
    </Router>
  );
}

export default App;
